"use client"

import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import MapaCategoriaVisual from "../components/MapaCategoriaVisual"

export default function MapaCompartilhado() {
  const { eventoId, categoriaNome } = useParams()
  const [evento, setEvento] = useState(null)
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState("")

  const nomeCategoriaDecodificado = decodeURIComponent(categoriaNome);

  useEffect(() => {
    const buscarEvento = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`https://api.ticketdovaqueiro.com/api/events/${eventoId}`)
        setEvento(response.data)
      } catch (error) {
        console.error("Erro ao buscar evento:", error)
        setErro("Evento não encontrado ou link inválido.")
      } finally {
        setLoading(false)
      }
    }

    if (eventoId) {
      buscarEvento()
    }
  }, [eventoId])

  if (loading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "#0a0a0a", color: "#fff" }}>
        <div className="loading-spinner23" style={{ width: 40, height: 40, borderTopColor: "#d4af37" }}></div>
        <p style={{ marginTop: 16 }}>Carregando mapa...</p>
      </div>
    )
  }

  if (erro || !evento) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "#0a0a0a", color: "#ef4444" }}>
        <h2>{erro || "Erro desconhecido."}</h2>
      </div>
    )
  }

  return (
    <div style={{ 
      minHeight: "100vh", 
      backgroundColor: "#0a0a0a", 
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <div style={{ width: "100%", maxWidth: "800px", background: "#171717", padding: "20px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.05)" }}>
        {/* Usamos o componente passando a flag modoCompartilhado=true */}
        <MapaCategoriaVisual 
            evento={evento} 
            categoriaSelecionada={nomeCategoriaDecodificado} 
            modoCompartilhado={true} 
        />
      </div>
      
      <div style={{ marginTop: 20, textAlign: "center", opacity: 0.5 }}>
         <img src="/logo.png" alt="Ticket do Vaqueiro" style={{ height: 24, marginBottom: 8 }} />
         <p style={{ fontSize: 12, color: "#fff", margin: 0 }}>Tecnologia Ticket do Vaqueiro</p>
      </div>
    </div>
  )
}